var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.472 19.5c0 .828-.671 1.5-1.498 1.5H1.998c-.827 0-1.499-.672-1.499-1.5v-11l11.487-8 11.486 8v11z",
    transform: "translate(-289 -670) translate(276 657) translate(13.153 13) translate(.5 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.496 17.5L8.49 14 15.481 14 20.475 17.5M23.472 8.5L17.479 12.5M.499 8.5L6.492 12.5",
    transform: "translate(-289 -670) translate(276 657) translate(13.153 13) translate(.5 2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d6210eed.svg";
export { ForwardRef as ReactComponent };